import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {
  Calendar,
  TeamEventMeetingType,
  HostUserInterface,
} from '@vendasta/meetings';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { BookMeNowStoreService } from '../book-me-now-store.service';

@Component({
  selector: 'app-bookme-banner',
  templateUrl: './bookme-banner.component.html',
  styleUrls: ['./bookme-banner.component.scss'],
  standalone: false,
})
export class BookmeBannerComponent implements OnInit, OnDestroy {
  calendar$: Observable<Calendar>; // Observable to hold the calendar data
  teamMemberList$: Observable<HostUserInterface[]>;
  displayName$: Observable<string>;
  displayNameTooltip$: Observable<string>;
  displayNameTooltip = '';
  private tooltipSub: Subscription;

  constructor(
    private readonly bookmenowStoreService: BookMeNowStoreService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.calendar$ = this.bookmenowStoreService.calendar$;
    this.teamMemberList$ = this.bookmenowStoreService.teamMemberList$;

    this.displayName$ = combineLatest([
      this.bookmenowStoreService.teamEventMeetingType$,
      this.bookmenowStoreService.teamMemberList$,
      this.bookmenowStoreService.calendar$,
      this.bookmenowStoreService.displayName$,
    ]).pipe(
      map(([meetingType, memberList, calendar, displayName]) => {
        let nameString = '';
        if (displayName) {
          nameString = displayName;
        } else if (meetingType === TeamEventMeetingType.MULTI_HOST) {
          nameString = (memberList || [])
            .map((member) => member.displayName)
            .join(', ');
        } else {
          nameString = calendar?.displayName || '';
        }
        if (nameString.length > 40) {
          return nameString.slice(0, 40) + '...';
        }
        return nameString;
      })
    );

    this.displayNameTooltip$ = combineLatest([
      this.bookmenowStoreService.teamEventMeetingType$,
      this.bookmenowStoreService.teamMemberList$,
      this.bookmenowStoreService.calendar$,
    ]).pipe(
      map(([meetingType, memberList, calendar]) => {
        if (meetingType === TeamEventMeetingType.MULTI_HOST) {
          return (memberList || [])
            .map((member) => member.displayName)
            .join(', ');
        } else {
          return calendar?.displayName || '';
        }
      })
    );

    this.tooltipSub = this.displayNameTooltip$.subscribe((value) => {
      this.displayNameTooltip = value;
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    if (this.tooltipSub) {
      this.tooltipSub.unsubscribe();
    }
  }
}
